export default "__VITE_ASSET__yl0ePDVf__"